<sb-dialog-activation
  [showTitle]="step === TimeTrackingDialogStep.TEASER"
  [showBackButton]="step > 0"
  [showProgressBar]="step > 0"
  [currentStep]="step"
  [totalSteps]="steps"
  (back)="goBack()"
>
  <div main-panel>
    @switch (step) {
      @case (TimeTrackingDialogStep.TEASER) {
        <chapter-step
          [subtitle]="'Time tracking' | translate"
          [title]="'Stop time tracking from costing you time &dash; and money.' | translate"
          [nextButtonLabel]="'Start quick setup' | translate"
          (next)="goToStep(TimeTrackingDialogStep.TRACKING_METHOD)"
        >
          <div class="flex flex-col gap-1">
            <chapter-item [text]="'Save on labor costs by reducing errors and optimizing hours.' | translate" />
            <chapter-item [text]="'Track every hour accurately with real-time data.' | translate" />
            <chapter-item [text]="'Simplify compliance and stay on top of labor laws.' | translate" />
          </div>
          <p class="text-base">
            {{ "Let's configure your time tracking to start saving." | translate }}
          </p>
        </chapter-step>
      }
      @case (TimeTrackingDialogStep.TRACKING_METHOD) {
        <time-tracking-tracking-method
          [nextButtonLoading]="nextButtonLoading"
          (next)="onTrackingMethodChange($event)"
        />
      }
      @case (TimeTrackingDialogStep.TRACKING_ACCURACY) {
        <chapter-step
          [title]="'Your time tracking is set for accuracy.' | translate"
          [nextButtonLabel]="'Got it!' | translate"
          (next)="goToStep(TimeTrackingDialogStep.AUTO_APPROVE_HOURS)"
        >
          <div class="flex flex-col gap-8">
            <p class="m-0 text-base">
              {{ "We've configured default rounding to ensure accurate and fair timesheets:" | translate }}
            </p>
            <div class="flex flex-col gap-1">
              <chapter-item
                [icon]="'clock'"
                [text]="'Start time' | translate"
                [description]="'Rounded to the shift start if clocked in up to 1 hour early.' | translate"
              />
              <chapter-item
                [icon]="'clock'"
                [text]="'End time' | translate"
                [description]="'Rounded to the shift end if clocked out within 15 minutes after.' | translate"
              />
              <chapter-item
                [icon]="'clock'"
                [text]="'Clock-in/out times' | translate"
                [description]="'Adjusted to the nearest 15 minutes.' | translate"
              />
            </div>
            <p class="m-0 text-base">
              {{ "You can fine-tune these settings anytime to match your team's needs." | translate }}
            </p>
          </div>
        </chapter-step>
      }
      @case (TimeTrackingDialogStep.AUTO_APPROVE_HOURS) {
        <time-tracking-auto-approve-hours
          [nextButtonLoading]="nextButtonLoading"
          (next)="onAutoApproveHoursChange($event)"
        />
      }
      @case (TimeTrackingDialogStep.AUTO_APPROVE_SCHEDULE) {
        <time-tracking-auto-approve-schedule
          [nextButtonLoading]="nextButtonLoading"
          (next)="onAutoApproveScheduleChange($event)"
        />
      }
      @case (TimeTrackingDialogStep.CLOCKING_LOCATION) {
        <time-tracking-clocking-location
          [nextButtonLoading]="nextButtonLoading"
          [skipButtonLoading]="skipButtonLoading"
          (next)="savePreferencesAndClose()"
          (locationChange)="onLocationChange($event)"
          (skip)="savePreferencesAndClose(true)"
        />
      }
    }
  </div>
  <div
    class="flex size-full min-h-72 overflow-hidden rounded-lg bg-cover bg-center bg-no-repeat lg:mr-12"
    aside-panel
    [ngStyle]="{
      backgroundImage:
        step !== TimeTrackingDialogStep.CLOCKING_LOCATION
          ? 'url(assets/images/onboarding/chapters/time-tracking.jpg)'
          : 'none',
    }"
  >
    @if (step === TimeTrackingDialogStep.CLOCKING_LOCATION) {
      <sb-maps
        class="size-full"
        [latitude]="selectedLocationMarker?.lat"
        [longitude]="selectedLocationMarker?.lng"
        [markers]="selectedLocationMarker && [selectedLocationMarker]"
        [fitMarkerBounds]="!!selectedLocationMarker"
        [zoom]="17"
        [defaultHeight]="false"
        [iteractable]="false"
      />
    }
  </div>
</sb-dialog-activation>
